import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[sharedSearchOption]',
})
export class SearchOptionDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
